/**
 * User: Faris
 * Date: 6/24/13
 * Time: 12:21 PM
 */

define('app/models/modal',['require'],function(require) {

  return Backbone.Model.extend({

    defaults: {
      title: '',
      message: '',
      buttons: [
        {
          type: 'close',
          label: 'Close',
          callback: function(){}
        }
      ]
    }

  });

});
